interface AppConfig {
  delayToResendAccountConfirmationEmails: string;
  apiBaseUrl: string;
  appName: string;
  supportEmail: string;
  isProductionEnvironment: boolean;
  isNonProductionEnvironment: boolean;
  authCookieName: string;
  features: {
    darkMode: boolean;
    emailVerification: boolean;
    passwordReset: boolean;
    turnstileProtection: boolean;
    csrfProtection: boolean;
  };
  turnstileSiteKey: string;
  oauth: {
    google: boolean;
    microsoft: boolean;
    facebook: boolean;
    github: boolean;
  };
  ui: {
    primaryColor: string;
    secondaryColor: string;
    theme: `light` | `dark` | `auto`;
  };
}

const defaultConfig: AppConfig = {
  delayToResendAccountConfirmationEmails: import.meta.env.VITE_DELAY_RESEND_EMAIL ?? `5`,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? ``,
  appName: import.meta.env.VITE_APP_NAME || `App`,
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL || `support@${import.meta.env.VITE_SSO_DOMAIN}`,
  isProductionEnvironment: import.meta.env.VITE_NODE_ENV === `production`,
  isNonProductionEnvironment: import.meta.env.VITE_NODE_ENV !== `production`,
  authCookieName: import.meta.env.VITE_AUTH_COOKIE_NAME || `auth`,
  features: {
    darkMode: import.meta.env.VITE_FEATURE_DARK_MODE !== `false`,
    emailVerification: import.meta.env.VITE_FEATURE_EMAIL_VERIFICATION !== `false`,
    passwordReset: import.meta.env.VITE_FEATURE_PASSWORD_RESET !== `false`,
    turnstileProtection: import.meta.env.VITE_TURNSTILE_PROTECTION === `true`,
    csrfProtection: import.meta.env.VITE_CSRF_PROTECTION === `true`,
  },
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY ?? ``,
  oauth: {
    google: import.meta.env.VITE_AUTH_GOOGLE_ENABLED === `true`,
    microsoft: import.meta.env.VITE_AUTH_MICROSOFT_ENABLED === `true`,
    facebook: import.meta.env.VITE_AUTH_FACEBOOK_ENABLED === `true`,
    github: import.meta.env.VITE_AUTH_GITHUB_ENABLED === `true`,
  },
  ui: {
    primaryColor: import.meta.env.VITE_UI_PRIMARY_COLOR || `blue`,
    secondaryColor: import.meta.env.VITE_UI_SECONDARY_COLOR || `orange`,
    theme: (import.meta.env.VITE_UI_DEFAULT_THEME as `light` | `dark` | `auto`) || `auto`,
  },
};

export const config = defaultConfig;
export type { AppConfig };
